module.exports = __webpack_public_path__ + "static/media/cny-set-2023-5.070ba8f9.gif";